import { MemberModel } from "./member.model";

export class BreakModel extends MemberModel {

    /**
     * ä¼æ¯æé , å®ä½ï¼æ¯«ç§ï¼
     */
    time : number ;

    /**
     * ä¼æ¯åå 
     */
    reason : string
}
